import CursorPagination from './CursorPagination';

export default CursorPagination;
